import React, { useState } from "react";
import IMAGES from "../Images";
import { MainContainer, FlexContainer } from "../assets/styles/theme/styles";
import styled from "styled-components";
import Heading from "./Heading";
import theme from "../assets/styles/theme/theme";
import Paragraph from "./Paragraph";
import Button from "./ Button";

export default function ThreeCards({
  title,
  titleDes,
  btn,
  subtitle,
  description,
  helpItems,
  cols,
}) {
  const [changeTitle, setChangeTitle] = useState(subtitle);
  const [changeDescription, setChangeDescription] = useState(description);

  const handleIconHover = (src) => {
    setChangeTitle(src.title);
    setChangeDescription(src.description);
  };
  return (
    <>
      <MainContainer>
        <div style={{ marginBottom: "2rem", maxWidth: "1000px" }}>
          <Heading level={1}>{title}</Heading>
          {titleDes && <Paragraph level={3}>{titleDes}</Paragraph>}
        </div>
        <FlexContainer flxdrn="row-reverse" jfycont="space-around">
          <TextContainer>
            <h5>{changeTitle}</h5>
            <p>{changeDescription}</p>
            {btn && <Button text={btn} />}
          </TextContainer>
          <WeHelpContainer columns={cols}>
            {helpItems.map((val, index) => {
              return (
                <WeHelpItem
                  key={index}
                  columns={cols}
                  onMouseEnter={() => handleIconHover(val)}
                >
                  <img src={val.image} alt={val.title} />
                  <p>{val.title}</p>
                </WeHelpItem>
              );
            })}
          </WeHelpContainer>
        </FlexContainer>
      </MainContainer>
    </>
  );
}

const TextContainer = styled.div`
  text-align: center;
  margin-top: 2rem;
  max-width: 494px;
  width: 100%;

  @media (min-width: 720px) {
    margin-top: 3rem;
    text-align: left;
  }
  @media (min-width: 1020px) {
    text-align: left;
  }
  h5 {
    border-radius: 12px;
    color: ${theme.colors.primary};
    // font-size: 27px;
    font-size: ${theme.fontSizes.heading3};
    // @media (min-width: 1020px) {
    //   text-align: left;
    // }
  }
  p {
    font-size: ${theme.fontSizes.paragraph4};
    color: ${theme.colors.secondary};
    max-width: 447px;
  }
`;

const WeHelpContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  // margin: 0 auto;
  // justify-content: center;

  @media (min-width: 720px) {
    grid-template-columns: ${(props) => {
      return props.columns == 2 ? "repeat(2, 1fr)" : "repeat(3, 1fr)";
    }};
    grid-template-rows: ${(props) =>
      props.columns == 2 ? "" : "repeat(4, 1fr)"};

    // height: 500px;
  }
`;

const WeHelpItem = styled.div`
  padding: 1rem;
  border-radius: 10px;
  background-color: ${theme.bgColors.primary};
  box-shadow: ${theme.shadows.default};
  width: ${(props) => (props.columns == 5 ? "130px" : "170px")};
  height: ${(props) => (props.columns == 5 ? "130px" : "170px")};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  @media (min-width: 720px) {
    // width: 200px;
    ${(props) =>
      props.columns != 2 &&
      `&:nth-child(1) {
        grid-column: 1 / 2;
        grid-row: 1 / 3;
      }
      &:nth-child(2) {
        grid-column: 1 / 2;
        grid-row: 3 / 5;
      }
      &:nth-child(3) {
        grid-column: 2 / 3;
        grid-row: 2 / 4;
      }
      &:nth-child(4) {
        grid-column: 3 / 4;
        grid-row: 1 / 3;
      }
      &:nth-child(5) {
        grid-column: 3 / 4;
        grid-row: 3 / 5;
      }
    `}
  }

  img {
    // width: 38px !important;
    height: 100px;
    object-fit: contain;
  }
  h3 {
    margin: 10px 0;
  }
  p {
    line-height: 1.6em;
    color: ${theme.colors.secondary};
    text-align: center;
    font-size: 14px;
    max-width: 215px;
    padding: 0px 12px;
  }
  &:hover {
    box-shadow: ${theme.shadows.hover};
    cursor: pointer;
  }
`;
